import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SpreadsheetGuide from "../pages/article/SpreadsheetGuide";
import ArticlePage from "../pages/article/ArticlePage";
import { Navigate } from "react-router-dom";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/pt/" replace />,
  },
  {
    path: "/:lang/",
    element: <Home />,
  },
  {
    path: "/:lang/cssbuy-spreadsheet/",
    element: <SpreadsheetGuide />,
  },
  {
    path: "/:lang/article/:slug/",
    element: <ArticlePage />,
  },
  {
    path: "/:lang/about/",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/:lang/safety/",
    element: <Navigate to="/" replace />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;